import { useEffect } from "react"
import { useOutletContext } from "react-router"
import {
  selectResetStore,
  selectRootCustomerId,
  selectSetDisableInteractions,
  selectSetRootCustomerId
} from "@/domains/visualization/store/selectors"
import { useGraphStore } from "@/domains/visualization/store/store"
import { CustomerContent } from "../components/CustomerContent/CustomerContent"
import type { CustomerContext } from "../types/CustomerContext"

export function CustomerPage() {
  const { customer } = useOutletContext<CustomerContext>()
  const currentRootId = useGraphStore(selectRootCustomerId)
  const resetStore = useGraphStore(selectResetStore)
  const setRootCustomerId = useGraphStore(selectSetRootCustomerId)
  const setDisableInteractions = useGraphStore(selectSetDisableInteractions)

  useEffect(() => {
    if (currentRootId !== customer.id) {
      resetStore()
      setRootCustomerId(customer.id)
    }
    setDisableInteractions(true)

    return () => {
      setDisableInteractions(false)
    }
  }, [customer.id, currentRootId, resetStore, setRootCustomerId, setDisableInteractions])
  return <CustomerContent customer={customer} />
}
